import { atom } from 'jotai';

export type ClaimableFTOInfo = {
	amount: number;
	endDate?: string;
	fanTokenOfferingId: string;
	ftoContractAddress: string;
	logoSrc: string;
	partnerId: string;
	partnerName: string;
	tokenContractAddress: string;
	tokenShortCode: string;
};

export const ClaimableFTOAtom = atom<ClaimableFTOInfo | undefined>(undefined);
